import React from 'react';
import {stringsTranslate} from "../../../locales/CustomTranslater";
import {appWords} from "../../../config/Constants";


export default function Section2and3ForCompanies() {


    const initStrings = {
        headingSection1: stringsTranslate(appWords.knaekapp_social_alternative_title),
        subheadingSection1_1: stringsTranslate(appWords.tired_of_socials),
        subheadingSection1_2: stringsTranslate(appWords.coupon_duration_and_visibility),
        subheadingSection1_3: stringsTranslate(appWords.real_contact_at_counter),
        playImg1: "/assets/images/ForCompanies/Visual1 1.webp",

        headingSection2: stringsTranslate(appWords.experience_over_discount),
        subheadingSection2_1:  stringsTranslate(appWords.brand_loyalty_over_redemption),
        subheadingSection2_2: stringsTranslate(appWords.not_for_quick_sales_boost),
        subheadingSection2_3: stringsTranslate(appWords.limited_coupons_urgency_effect),
        playImg2: "/assets/images/ForCompanies/image 1.webp",
        img2Text: stringsTranslate(appWords.check_why_this_works),
    }

    return (
        <section className="section">
            <div className="container-fluid">

                {/*Section 2*/}

                <div className="row justify-content-center align-items-center px-2 px-md-5 px-lg-5 section2-for-companies">
                    <div className="col-lg-6 col-md-12">
                        <img src={initStrings.playImg1} alt={""}/>
                    </div>
                    <div className="col-lg-6 col-md-12 flex-wrap d-flex align-items-center mt-0 mt-md-5 mt-lg-5">
                        <h2 className={"m-0 m-md-3 m-lg-3 p-0 p-md-3 p-lg-3"}>{initStrings.headingSection1}
                            <p className={"mt-2 p-1 line-text"}>{initStrings.subheadingSection1_1}</p>
                            <p className={"mt-2 p-1 line-text"}>{initStrings.subheadingSection1_2}</p>
                            <p className={"mt-2 p-1 line-text"}>{initStrings.subheadingSection1_3}</p>
                        </h2>

                    </div>

                </div>

                {/*Section 3*/}

                <div className="row mt-5 section3-for-companies justify-content-center align-items-center px-2 px-md-5 px-lg-5 py-md-5 py-lg-5 py-4">
                    {/*Text under the logo */}
                    <div className="col-lg-6 col-md-12 flex-wrap d-flex align-items-center mt-5">
                        <h2 className={"pr-0 pr-md-5 pr-lg-5 mr-0 mr-lg-5 mr-md-5 text-left"}>{initStrings.headingSection2}
                            <p className={"mt-2 p-1 line-text"}>{initStrings.subheadingSection2_1}</p>
                            <p className={"mt-2 p-1 line-text"}>{initStrings.subheadingSection2_2}</p>
                            <p className={"mt-2 p-1 line-text"}>{initStrings.subheadingSection2_3}</p>
                        </h2>

                    </div>
                    <div className="col-lg-6 col-md-12 text-center mt-5 mt-md-0 mt-lg-0">
                        <img src={initStrings.playImg2} className={"radius-15 w-100 cursor-pointer px-1 mt-0 mt-lg-5 mt-md-5"} alt={""} onClick={()=> goToYouTube()}/>
                        <h5 className={"pt-3 pb-5"}>
                            <a className={"p-1 line-text border-bottom border-dark cursor-pointer"}
                               onClick={() => goToYouTube()}>{initStrings.img2Text}</a>
                        </h5>
                    </div>
                </div>
            </div>
        </section>
    );

    function goToYouTube() {
        if (window.location.href.toString().includes("give-student-discounts")) {
            window.open('https://www.youtube.com/watch?v=viGUvE0J8iQ')

        } else {
            window.open('https://www.youtube.com/watch?v=MsbjSpcfLm8')

        }

    }
}
